import { Tooltip as TooltipPrimitive } from "radix-ui";
import * as React from "react";

import { cn } from "@/utils/shadcn-ui";

export function TooltipProvider({
  delayDuration = 0,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      {...props}
    />
  );
}

export function Tooltip({
  content,
  children,
  className,
  side,
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Root> & {
  content: React.ReactNode;
  className?: string;
  side?: React.ComponentProps<typeof TooltipPrimitive.Content>["side"];
  sideOffset?: number;
}) {
  return (
    <TooltipPrimitive.Root
      data-slot="tooltip"
      disableHoverableContent
      {...props}
    >
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      {content && (
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            data-slot="tooltip-content"
            side={side}
            sideOffset={sideOffset}
            className={cn(
              "group bg-popover text-popover-foreground border border-border animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 pointer-events-none relative z-50 w-fit max-w-xs origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-pretty",
              className,
            )}
          >
            {content}
            {/* Radix measures the arrow's box and uses it for the offset, the
                arrow's centering and the zoom origin, so the box must be exactly
                the visible triangle (no CSS transforms on it). Radix rotates it
                per side; in its own frame y=0 is the tooltip's inner border edge,
                so the fill starts there to cover the border under the base and
                the stroke starts on the border's centerline (y=0.5) to continue
                the tooltip's outline. */}
            <TooltipPrimitive.Arrow asChild>
              <svg
                width={12}
                height={6}
                viewBox="0 0 12 6"
                className="fill-popover stroke-border overflow-visible"
              >
                <polygon points="0,0 12,0 12,0.5 6,6 0,0.5" stroke="none" />
                <polyline points="0,0.5 6,6 12,0.5" fill="none" />
              </svg>
            </TooltipPrimitive.Arrow>
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      )}
    </TooltipPrimitive.Root>
  );
}
